/** @jsx onetext.jsx.element */

import type { Variants } from '../standard';

export const weekOneVariants : Variants = {
    // Magic Spin Cables variants (AppLovin)
    SPIN_CABLE_DISCOUNT: {
        offerTextLine1:          'Up to 60% off',
        offerTextLine2:          'Magic Spin Cables',
        emailPromptText:         'Enter your email to claim your special offer',
        smsPromptText:           'with texts to claim up to 60% off Magic Spin Cables',
        teaserText:              'UP TO 60% OFF',
        showQuiz:                false,
        landingPageUrlPathnames: [ '/pages/magic-spin-cable-adr5' ],
        heroImage:               {
            url: 'https://static.onetext.com/misc/spin-1200x1200.png',
            alt: 'Magic Spin Cables'
        },
        propertyValues: {
            'OT - Campaign': 'APPLOVINSPIN',
            'OT - Test':     'DISCOUNT',
            'OT - Variant':  'SPIN_DISCOUNT'
        },
        externalID: 'spin_discount'
    },
    SPIN_CABLE_SHIPPING: {
        offerTextLine1:          'Unlock',
        offerTextLine2:          'Free Shipping!',
        emailPromptText:         'with orders over $35',
        smsPromptText:           'with texts to unlock free shipping on orders over $35',
        teaserText:              'Get Free Shipping',
        showQuiz:                false,
        landingPageUrlPathnames: [ '/pages/spin-cable-adr5-free-shipping' ],
        heroImage:               {
            url: 'https://static.onetext.com/misc/spin-1200x1200.png',
            alt: 'Magic Spin Cables'
        },
        propertyValues: {
            'OT - Campaign': 'APPLOVINSPIN',
            'OT - Test':     'SHIPPING',
            'OT - Variant':  'SPIN_SHIPPING'
        },
        externalID: 'spin_shipping'
    },
    SPIN_CABLE_FREE: {
        offerTextLine1:          'Win A Free',
        offerTextLine2:          'Magic Spin Cable',
        emailPromptText:         'Enter your email to claim your special offer',
        smsPromptText:           'with texts for a chance to win a Magic Spin Cable',
        teaserText:              'Win A Free Cable',
        showQuiz:                false,
        landingPageUrlPathnames: [ '/pages/spin-cable-adr5-free-spin-cable' ],
        heroImage:               {
            url: 'https://static.onetext.com/misc/spin-1200x1200.png',
            alt: 'Magic Spin Cables'
        },
        propertyValues: {
            'OT - Campaign': 'APPLOVINSPIN',
            'OT - Test':     'FREE',
            'OT - Variant':  'SPIN_FREE'
        },
        externalID: 'spin_free'
    },

    // Mint Spin Cable variants
    MINT_SPIN_CABLE_DISCOUNT: {
        offerTextLine1:          'Up to 60% off',
        offerTextLine2:          'Magic Spin Cables',
        emailPromptText:         'Enter your email to claim your special offer',
        smsPromptText:           'with texts to claim up to 60% off Magic Spin Cables',
        teaserText:              'UP TO 60% OFF',
        showQuiz:                false,
        landingPageUrlPathnames: [ '/pages/magic-spin-cable-purple' ],
        heroImage:               {
            url: 'https://static.onetext.com/misc/spin-mint-1200x1200.png',
            alt: 'Magic Spin Cables'
        },
        propertyValues: {
            'OT - Campaign': 'APPLOVINSPIN',
            'OT - Test':     'DISCOUNT',
            'OT - Variant':  'SPIN_DISCOUNT'
        },
        externalID: 'spin_discount_mint'
    },
    MINT_SPIN_CABLE_SHIPPING: {
        offerTextLine1:          'Unlock',
        offerTextLine2:          'Free Shipping!',
        emailPromptText:         'with orders over $35',
        smsPromptText:           'with texts to unlock free shipping on orders over $35',
        teaserText:              'Get Free Shipping',
        showQuiz:                false,
        landingPageUrlPathnames: [ '/pages/magic-spin-cable-mint-free-shipping' ],
        heroImage:               {
            url: 'https://static.onetext.com/misc/spin-mint-1200x1200.png',
            alt: 'Magic Spin Cables'
        },
        propertyValues: {
            'OT - Campaign': 'APPLOVINSPIN',
            'OT - Test':     'SHIPPING',
            'OT - Variant':  'SPIN_SHIPPING'
        },
        externalID: 'spin_shipping_mint'
    },
    MINT_SPIN_CABLE_FREE: {
        offerTextLine1:          'Win A Free',
        offerTextLine2:          'Magic Spin Cable',
        emailPromptText:         'Enter your email to claim your special offer',
        smsPromptText:           'with texts for a chance to win a Magic Spin Cable',
        teaserText:              'Win A Free Cable',
        showQuiz:                false,
        landingPageUrlPathnames: [ '/pages/magic-spin-cable-mint-free-spin-cable' ],
        heroImage:               {
            url: 'https://static.onetext.com/misc/spin-mint-1200x1200.png',
            alt: 'Magic Spin Cables'
        },
        propertyValues: {
            'OT - Campaign': 'APPLOVINSPIN',
            'OT - Test':     'FREE',
            'OT - Variant':  'SPIN_FREE'
        },
        externalID: 'spin_free_mint'
    },

    // Open Earbuds variants (Meta)
    OPEN_EARBUDS_DISCOUNT: {
        offerTextLine1:          '30% off',
        offerTextLine2:          'Open Earbuds',
        emailPromptText:         'Enter your email to claim your special offer',
        smsPromptText:           'with texts to claim 30% off Open Earbuds',
        teaserText:              'GET 30% OFF',
        showQuiz:                false,
        landingPageUrlPathnames: [ '/pages/raycon-open-earbuds-adr4' ],
        heroImage:               {
            url: 'https://static.onetext.com/misc/open-earbuds-1200x1200.png',
            alt: 'Open Earbuds'
        },
        propertyValues: {
            'OT - Campaign': 'METAO15',
            'OT - Test':     'DISCOUNT',
            'OT - Variant':  'OPEN_DISCOUNT'
        },
        externalID: 'open_discount'
    },
    OPEN_EARBUDS_SHIPPING: {
        offerTextLine1:          'Free Shipping on',
        offerTextLine2:          'Open Earbuds',
        emailPromptText:         'Enter your email to claim your special offer',
        smsPromptText:           'with texts to claim free shipping on Open Earbuds',
        teaserText:              'Get Free Shipping',
        showQuiz:                false,
        landingPageUrlPathnames: [ '/pages/raycon-open-earbuds-adr4-free-shipping' ],
        heroImage:               {
            url: 'https://static.onetext.com/misc/open-earbuds-1200x1200.png',
            alt: 'Open Earbuds'
        },
        propertyValues: {
            'OT - Campaign': 'METAO15',
            'OT - Test':     'SHIPPING',
            'OT - Variant':  'OPEN_SHIPPING'
        },
        externalID: 'open_shipping'
    },
    OPEN_EARBUDS_FREE: {
        offerTextLine1:          'Enter to win free',
        offerTextLine2:          'Open Earbuds',
        emailPromptText:         'Enter your email to claim your special offer',
        smsPromptText:           'with texts for a chance to win Open Earbuds',
        teaserText:              'Win Free Earbuds',
        showQuiz:                false,
        landingPageUrlPathnames: [ '/pages/raycon-open-earbuds-adr4-free-open-earbuds' ],
        heroImage:               {
            url: 'https://static.onetext.com/misc/open-earbuds-1200x1200.png',
            alt: 'Open Earbuds'
        },
        propertyValues: {
            'OT - Campaign': 'METAO15',
            'OT - Test':     'FREE',
            'OT - Variant':  'OPEN_FREE'
        },
        externalID: 'open_free'
    }
};
